import { Component, OnInit } from '@angular/core';
import { SidemenuService } from 'src/app/services/sidemenu/sidemenu.service';

@Component({
  selector: 'app-sidemenu-tabs',
  templateUrl: './sidemenu-tabs.component.html',
  styleUrls: ['./sidemenu-tabs.component.scss'],
})
export class SidemenuTabsComponent implements OnInit {

  public productVerticals: any[] = [];
  public homeConfig: any;

  constructor(
    private sidemenuService: SidemenuService,
  ) {
    this.productVerticals = this.sidemenuService.getProductVerticals();
    this.homeConfig = this.sidemenuService.getHomeConfig();
  }

  ngOnInit() { }

  protected goToTab(vertical): any {
    return this.sidemenuService.goToTab(vertical);
  }

  protected goToHome(): any {
    this.sidemenuService.goToTab();
  }

}
